module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-main"
  }, [_c('div', {
    staticClass: "admin-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.tableParams,
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.status),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "status", $$v)
      },
      expression: "tableParams.status"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "待用",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "上架",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "下架",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择排序",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.orderBy),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "orderBy", $$v)
      },
      expression: "tableParams.orderBy"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "创建日期",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "上屏日期",
      "value": "startTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newQueryTaskClick
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.insertTaskClick
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchOnlineClick
    }
  }, [_vm._v("批量上架")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchOfflineClick
    }
  }, [_vm._v("批量下架")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.list,
      "stripe": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#DE5DB5",
            "font-weight": "600"
          }
        }, [_vm._v(_vm._s(scope.row.price))]), _vm._v("元\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "gray",
            "font-weight": "600"
          }
        }, [_vm._v("待用")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "green",
            "font-weight": "600"
          }
        }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "600"
          }
        }, [_vm._v("下架")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count",
      "label": "总数量",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useCount",
      "label": "已占数量",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unUseCount",
      "label": "剩余数量",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.unUseCount >= 10) ? _c('div', {
          staticStyle: {
            "color": "black",
            "font-weight": "400"
          }
        }, [_vm._v(_vm._s(scope.row.unUseCount))]) : _vm._e(), _vm._v(" "), (scope.row.unUseCount < 10 && scope.row.unUseCount > 0) ? _c('div', {
          staticStyle: {
            "color": "orange",
            "font-weight": "400"
          }
        }, [_vm._v(_vm._s(scope.row.unUseCount))]) : _vm._e(), _vm._v(" "), (scope.row.unUseCount == 0) ? _c('div', {
          staticStyle: {
            "color": "red",
            "font-weight": "600"
          }
        }, [_vm._v(_vm._s(scope.row.unUseCount))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editTaskInfoClick(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.toggleStatusClick(scope.row)
            }
          }
        }, [_vm._v("切换状态")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tableData.pageNum,
      "page-size": _vm.tableData.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.tableData.total
    },
    on: {
      "prev-click": function($event) {
        return _vm.changePage(-1)
      },
      "next-click": function($event) {
        return _vm.changePage(1)
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTaskInfo.newUpdateTitle,
      "visible": _vm.dialogTaskInfo.newUpdateVisible,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogTaskInfo, "newUpdateVisible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "dialog-person-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.dialogTaskInfo.taskInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "name", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上屏日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.selectDate),
      callback: function($$v) {
        _vm.selectDate = $$v
      },
      expression: "selectDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.count),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "count", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.count"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.price),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "price", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态",
      "clearable": ""
    },
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.status),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "status", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.status"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "待用",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "上架",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "下架",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newUpdateTaskClick
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-140b8c7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/hand/date_mgr.vue
// module id = 1177
// module chunks = 2